// Auto-generated from https://evolveamz.com/custom-jingles/
// Audio hot-linked from audio.evolveamz.com (your own subdomain — free hotlinking).

export interface Jingle {
  brand: string;
  product: string;
  industry: string;
  industrySlug: string;
  vocal: 'male' | 'female' | 'duet';
  mood: string;
  genre: string;
  genreLabel: string;
  audioSlug: string;
  description: string;
}

export const jingles: Jingle[] = [
  {
    "brand": "BOUNCEBAR",
    "product": "Protein Bars",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "duet",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "bouncebar-protein-bars-custom-jingle",
    "description": "Energetic upbeat pop duet for a protein bar brand. Male and female leads trading the hook for a workout-anthem feel that lands across Meta ads, TikTok UGC, and Amazon Sponsored Brand video."
  },
  {
    "brand": "COTTONBLOOM",
    "product": "Turkish Bath Towels",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "playful",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "Turkish-Cotton-Bath-towels-custom-jingle",
    "description": "Bright, playful pop for a Turkish bath towel brand. Bouncy male vocal and hook-forward production engineered to sell a premium home-textile product with genuine warmth, not stock-music filler."
  },
  {
    "brand": "PLUSHNEST",
    "product": "Plush Area Rug",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "warm",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "Plushnest-Area-Rug-custom-jingle",
    "description": "Warm feel-good pop for a plush area rug brand. Male lead over a soft bed of acoustic textures. Designed to pair with home-staging content, interior-design creative, and DTC rug launches."
  },
  {
    "brand": "IMMUNENOVA",
    "product": "Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "male",
    "mood": "playful",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "",
    "description": "Feel-good pop for a daily immunity supplement. Upbeat male vocal and a hooky chorus engineered to land inside 15-second Sponsored Brand and Meta ads in the DTC wellness category."
  },
  {
    "brand": "COOLWAVE",
    "product": "Beach Cooler",
    "industry": "Outdoor & Sporting",
    "industrySlug": "outdoor-sporting",
    "vocal": "male",
    "mood": "chill",
    "genre": "tropical",
    "genreLabel": "Tropical",
    "audioSlug": "coolwave-beach-cooler-custom-jingle",
    "description": "Chilled tropical pop for a premium beach cooler brand. Steel-drum textures and a relaxed male vocal engineered for beach, poolside, and summer-lifestyle creative placements."
  },
  {
    "brand": "EMBER & OAK",
    "product": "Frozen Drink Cubes",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "ember-oak-frozen-drink-cubes-custom-jingle",
    "description": "Sun-soaked upbeat pop for a premium cocktail cube brand. Warm production and confident male lead built for backyard, happy-hour, and cocktail-content placements."
  },
  {
    "brand": "HEAVENMUG",
    "product": "Insulated Coffee Tumbler",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "male",
    "mood": "warm",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "heavenmug-insulated-coffee-tumbler-custom-jingle",
    "description": "Smooth-pop brand bed for a travel drinkware brand. Male vocal over a relaxed groove that sits naturally under morning-routine creative and lifestyle UGC."
  },
  {
    "brand": "CRISPFALL",
    "product": "Cereal",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "duet",
    "mood": "warm",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "crispfall-cereal-custom-jingle",
    "description": "Warm feel-good pop duet for a breakfast cereal brand. Male and female leads harmonizing over a morning-kitchen groove. Built to pair with family-scene UGC and morning-routine content."
  },
  {
    "brand": "GLIDEWAY",
    "product": "Electric Scooters",
    "industry": "Outdoor & Sporting",
    "industrySlug": "outdoor-sporting",
    "vocal": "male",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "glideway-scooters-custom-jingle",
    "description": "High-energy pop with forward-motion drums and a chantable male hook. Built for urban mobility content and active-lifestyle paid ad creative."
  },
  {
    "brand": "NEON RUSH",
    "product": "Nail Polish",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "female",
    "mood": "bold",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "neon-rush-nail-polish-custom-jingle",
    "description": "Bright, bold pop for a statement nail polish brand. Confident female vocal and color-pop production designed for beauty ad creative and TikTok Shop placements."
  },
  {
    "brand": "OBSIDIAN SHAVE",
    "product": "Razor Blades",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "male",
    "mood": "bold",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "obsidian-shave-razor-blades-custom-jingle",
    "description": "Dark smooth-pop for a premium men's grooming brand. Understated male vocal and confident production that signals quality without trying too hard."
  },
  {
    "brand": "CRISPVAULT",
    "product": "Air Fryer",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "bold",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "crispvault-eight-flat-custom-jingle",
    "description": "Bold upbeat pop for a premium air fryer brand. Confident female lead and hook-forward production built to drive conversions on kitchen-gadget and healthy-cooking ad creative."
  },
  {
    "brand": "PREPWISE",
    "product": "Portion Containers",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "male",
    "mood": "energetic",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "prepwise-cup-portions-containers-custom-jingle",
    "description": "Clean, upbeat feel-good pop for a meal-prep brand. Male vocal and driving percussion built to energize weekly-planning content and fitness-adjacent ads."
  },
  {
    "brand": "SLEEPWELL MOON",
    "product": "Sleep Aid Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "male",
    "mood": "dreamy",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "sleepwell-moon-sleep-aid-custom-jingle",
    "description": "Atmospheric smooth pop for a natural sleep aid supplement. Soft male vocal and ambient layering designed to signal rest and wind-down before a single word of copy is read."
  },
  {
    "brand": "HONEYNOOK",
    "product": "Honey Dispenser",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "warm",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "honeynook-drip-custom-jingle",
    "description": "Warm smooth pop for a premium honey dispenser brand. Female vocal over a mellow groove that signals craft and quality. Built for kitchen-counter UGC and breakfast-scene creative."
  },
  {
    "brand": "SLICKTOP",
    "product": "Hair Gel \u2014 V1",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "male",
    "mood": "bold",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "slicktop-hair-gel-custom-jingle",
    "description": "Confident upbeat pop for a men's hair styling brand. Punchy male vocal and radio-polished production engineered for grooming ad creative and barbershop content."
  },
  {
    "brand": "SLICKTOP",
    "product": "Hair Gel \u2014 V2",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "male",
    "mood": "bold",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "slicktop-shine-custom-jingle",
    "description": "Second Slicktop production with a shine-focused lyrical angle. Same bold upbeat pop DNA with an alternate chorus built for secondary campaign creative."
  },
  {
    "brand": "HONEYWILD",
    "product": "Wildflower Honey",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "honeywild-jarlight-custom-jingle",
    "description": "Warm acoustic pop for a small-batch wildflower honey brand. Male vocal over finger-picked guitar that signals real ingredients and an artisan process. Pairs with bee-to-jar and craft-food creative."
  },
  {
    "brand": "WHISKUP",
    "product": "Silicone Spatulas",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "female",
    "mood": "playful",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "",
    "description": "Bright, playful feel-good pop for a silicone spatula brand. Bouncy melody and female lead that pairs naturally with baking UGC, Instagram recipe content, and kitchen lifestyle creative."
  },
  {
    "brand": "MINCEPRO",
    "product": "Garlic Press",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "male",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "",
    "description": "Punchy pop anthem for a premium garlic press brand. Driving beat and confident male vocal engineered to cut through food content, cooking reels, and product demo creative."
  },
  {
    "brand": "JUNIPERFALL",
    "product": "Apple Cider",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "juniperfall-apple-cider-custom-jingle",
    "description": "Warm acoustic-pop for a craft apple cider brand. Male vocal over a fall-palette guitar bed. Pairs with orchard, harvest, and autumn-seasonal creative placements."
  },
  {
    "brand": "CANDLEMOOR",
    "product": "Luxury Soy Candles \u2014 V1",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "luxury",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "candlemoor-luxury-soy-candles-custom-jingle",
    "description": "Elegant smooth-pop brand anthem for a luxury home fragrance brand. Polished male vocal and refined production that positions the product as aspirational, not just functional."
  },
  {
    "brand": "CANDLEMOOR",
    "product": "Luxury Soy Candles \u2014 V2",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "luxury",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "candlemoor-luxury-soy-candles-custom-jingle-v2",
    "description": "Alternate Candlemoor direction with shifted melodic content. Same luxury smooth-pop palette, tuned for campaign A/B testing against V1."
  },
  {
    "brand": "MOSSMARK",
    "product": "Dark Chocolate",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "playful",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "mossmark-purple-wrap-custom-jingle",
    "description": "Playful feel-good pop for a premium dark chocolate brand. Male lead over a rich, bright groove engineered to position an indulgent category as modern, craveable, and gift-ready."
  },
  {
    "brand": "CLEANWAVE",
    "product": "Cleaning Product \u2014 V1",
    "industry": "Cleaning & Household",
    "industrySlug": "cleaning-household",
    "vocal": "male",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "cleanwave-custom-jingle",
    "description": "Crisp upbeat pop for a cleaning product brand. Bright male vocal and a 'fresh start' melodic hook engineered for household content and Amazon Sponsored Brand ads."
  },
  {
    "brand": "CLEANWAVE",
    "product": "Cleaning Product \u2014 V2",
    "industry": "Cleaning & Household",
    "industrySlug": "cleaning-household",
    "vocal": "male",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "cleanwave-custom-jingle-v2",
    "description": "Second Cleanwave direction with an alternate chorus and tempo tweak. Same energetic upbeat pop palette, built for creative rotation."
  },
  {
    "brand": "GROOVE CUT",
    "product": "Bamboo Knives \u2014 V1",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "male",
    "mood": "warm",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "groove-cut-bamboo-knives-custom-jingle",
    "description": "Warm feel-good pop for a sustainable cutlery brand. Earthy male vocal and organic production that matches the natural material story."
  },
  {
    "brand": "GROOVE CUT",
    "product": "Bamboo Knives \u2014 V2",
    "industry": "Kitchen & Cookware",
    "industrySlug": "kitchen-cookware",
    "vocal": "male",
    "mood": "warm",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "groove-cut-bamboo-knives-custom-jingle-v2",
    "description": "Alternate Groove Cut direction with a different melodic angle. Same warm feel-good pop palette, engineered for campaign A/B testing."
  },
  {
    "brand": "NIGHTFORGE",
    "product": "Creatine Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "dreamy",
    "genre": "indie-pop",
    "genreLabel": "Indie Pop",
    "audioSlug": "nightforge-after-dark-custom-jingle",
    "description": "Atmospheric indie pop for a premium creatine supplement. Hushed female vocal and cinematic production that positions a fitness staple as modern, considered, and built for serious lifters."
  },
  {
    "brand": "LUMENBED",
    "product": "Weighted Blanket \u2014 V1",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "dreamy",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "lumenbed-weighted-blanket-custom-jingle",
    "description": "Dreamy smooth-pop for a sleep and wellness brand. Floating male vocal and a soft pad stack that signals comfort and rest from the first bar."
  },
  {
    "brand": "LUMENBED",
    "product": "Weighted Blanket \u2014 V2",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "dreamy",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "lumenbed-weighted-blanket-custom-jingle-v2",
    "description": "Alternate Lumenbed direction with shifted melodic content. Same dreamy smooth-pop palette for creative rotation."
  },
  {
    "brand": "ROSEWELL",
    "product": "Weekly Flower Delivery \u2014 V1",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "warm",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "rosewell-flowers-custom-jingle",
    "description": "Warm acoustic pop for a subscription weekly flower delivery service. Intimate male vocal and a nylon-string guitar bed that lands softly under gift, subscription, and recurring-delivery creative."
  },
  {
    "brand": "ROSEWELL",
    "product": "Weekly Flower Delivery \u2014 V2",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "warm",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "rosewell-flowers-custom-jingle-v2",
    "description": "Second Rosewell direction for the subscription flower delivery service. Same warm acoustic-pop palette with alternate lyrical content, tuned for seasonal campaigns and creative rotation."
  },
  {
    "brand": "NOCTURNE",
    "product": "Multivitamin Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "luxury",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "nocturne-no-26-custom-jingle",
    "description": "Elegant smooth pop for a premium multivitamin brand. Polished female vocal and refined production that positions a daily wellness staple as aspirational, not commoditized."
  },
  {
    "brand": "GIDLI",
    "product": "Kitchen Scissors \u2014 V1",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "female",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "gidli-scissors-custom-jingle-v1",
    "description": "A punchy upbeat pop anthem for a premium kitchen scissors brand. Built around a three-word vocal hook engineered to stick after a single listen. First direction of a two-part demo series."
  },
  {
    "brand": "GIDLI",
    "product": "Kitchen Scissors \u2014 V2",
    "industry": "Beauty & Personal Care",
    "industrySlug": "beauty-personal-care",
    "vocal": "male",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "gidli-scissors-custom-jingle-v2",
    "description": "Second direction of the Gidli kitchen scissors demo series. Same brand DNA with a slower tempo and a more melodic, emotional chorus line. Built to run during flash-sale and promo creative."
  },
  {
    "brand": "RUMBLEBOX",
    "product": "Bluetooth Speaker",
    "industry": "Outdoor & Sporting",
    "industrySlug": "outdoor-sporting",
    "vocal": "male",
    "mood": "energetic",
    "genre": "edm",
    "genreLabel": "EDM",
    "audioSlug": "rumblebox-rumble-custom-jingle",
    "description": "High-voltage EDM pop for a portable Bluetooth speaker brand. Drop-forward production and a shouted male hook that showcases the product's own sound signature inside the ad itself."
  },
  {
    "brand": "JOINTLY",
    "product": "Men's Supplement \u2014 V1",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "male",
    "mood": "bold",
    "genre": "country",
    "genreLabel": "Country",
    "audioSlug": "jointly-for-men-country-custom-jingle-v1",
    "description": "Modern pop-country hook for a men's joint and mobility supplement targeting a 35-55 year-old customer base. Acoustic guitars, punchy snares, and a confident male lead."
  },
  {
    "brand": "JOINTLY",
    "product": "Men's Supplement \u2014 V2",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "male",
    "mood": "bold",
    "genre": "country",
    "genreLabel": "Country",
    "audioSlug": "jointly-for-men-country-custom-jingle-v2",
    "description": "Second Jointly direction with a grittier, bar-band energy. Harder-hitting chorus and the same radio-friendly lyrical hook. Tuned for a mature country-leaning audience."
  },
  {
    "brand": "SUNROOT",
    "product": "Granola Bars",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "sunroot-granola-bars-custom-jingle",
    "description": "Warm feel-good pop for a granola bar brand. Male vocal and organic instrumentation that pairs with morning-routine, trail-ready, and wellness-lifestyle creative."
  },
  {
    "brand": "THRYVWELL",
    "product": "Roller Pain Relief \u2014 V1",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "thryvwell-roller-pop-custom-jingle-v1",
    "description": "Bright upbeat pop for a topical pain relief roller. Anthemic female vocal, driving hi-hats, and a chorus hook engineered to land inside a 15-second Amazon Sponsored Brand cut."
  },
  {
    "brand": "THRYVWELL",
    "product": "Roller Pain Relief \u2014 V2",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "thryvwell-roller-pop-custom-jingle-v2",
    "description": "Second Thryvwell pain-relief production with a deeper groove and a more contemplative opening. Same chorus payoff, different emotional on-ramp. Built for retargeting creative."
  },
  {
    "brand": "THUNDERCHIP",
    "product": "Tortilla Chips",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "bold",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "thunderchip-tortilla-custom-jingle",
    "description": "Bold upbeat pop for a tortilla chip brand. Driving male vocal and snack-aisle energy engineered for game-day, party, and snack-break creative."
  },
  {
    "brand": "MOONLOFT",
    "product": "PJs Sleepwear \u2014 V2",
    "industry": "Apparel & Accessories",
    "industrySlug": "apparel-accessories",
    "vocal": "female",
    "mood": "dreamy",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "",
    "description": "Gentle acoustic-pop for a sleepwear brand. Warm guitar bed, close-mic'd female vocal. A sound that matches the softness of the product category without going to sleep."
  },
  {
    "brand": "HARBORHILL COFFEE",
    "product": "Coffee",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "warm",
    "genre": "soul-r-b",
    "genreLabel": "Soul/R&amp;B",
    "audioSlug": "",
    "description": "Soulful vocal-forward anthem for a premium coffee brand. Warm keys, vintage horns, and a rich female lead designed to live inside morning-routine UGC creative."
  },
  {
    "brand": "VOLTNIGHT",
    "product": "Pre-Workout Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "duet",
    "mood": "energetic",
    "genre": "edm",
    "genreLabel": "EDM",
    "audioSlug": "voltnight-bloodstream-custom-jingle",
    "description": "High-energy EDM-pop duet for a pre-workout supplement brand. Male and female leads trading the chorus over a drop-forward beat built for gym, motion, and high-intensity creative."
  },
  {
    "brand": "SALTWOOD BBQ",
    "product": "BBQ Rubs & Spices",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "soul-r-b",
    "genreLabel": "Soul/R&amp;B",
    "audioSlug": "",
    "description": "Soulful slow-burn hook for a BBQ rubs and spices brand. Southern pocket, smoky male vocal, and a chorus line about rubbing flavor into everything it touches."
  },
  {
    "brand": "COASTLINE",
    "product": "Rum",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "chill",
    "genre": "tropical",
    "genreLabel": "Tropical",
    "audioSlug": "",
    "description": "Sun-kissed tropical pop for a rum brand. Steel drums, surf guitars, and a chilled male vocal. Built for poolside, island, and cocktail lifestyle creative."
  },
  {
    "brand": "WILLOWBEND",
    "product": "Iced Tea",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "chill",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "willowbend-iced-tea-custom-jingle",
    "description": "Chill acoustic-pop for a craft iced tea brand. Male vocal over a laid-back groove. Pairs naturally with porch, summer-afternoon, and slow-sip creative."
  },
  {
    "brand": "CRISPLINE",
    "product": "Chips",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "energetic",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "",
    "description": "High-energy upbeat pop for a premium chip brand. Bouncy synth bass, crowd claps, and a female hook engineered for snack-break moments inside social creative."
  },
  {
    "brand": "DRIFTSTONE",
    "product": "Watches",
    "industry": "Apparel & Accessories",
    "industrySlug": "apparel-accessories",
    "vocal": "male",
    "mood": "luxury",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "",
    "description": "Polished smooth-pop for a heritage watch brand. Subtle instrumentation and a confident male lead that positions the product as an aspirational everyday accessory."
  },
  {
    "brand": "FIRELAKE",
    "product": "Frozen Pizza",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "",
    "description": "Warm upbeat pop for a frozen pizza brand. Friday-night energy, confident male vocal, and a hook engineered to make the viewer hungry inside the first five seconds of the ad."
  },
  {
    "brand": "FONDUE CO",
    "product": "Fondue Kit",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "warm",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "",
    "description": "Extended upbeat pop for a premium fondue kit brand. Full verse, pre-chorus, chorus, and bridge structure. A long-form anthem that can be cut down into multiple shorter social and ad placements."
  },
  {
    "brand": "GREENHARBOR",
    "product": "Greens Powder Supplement",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "energetic",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "",
    "description": "Bright feel-good pop for a greens powder supplement brand. Female-led chorus and organic instrumentation that pairs naturally with morning-routine, wellness, and daily-ritual creative."
  },
  {
    "brand": "IRONCLAD",
    "product": "Propane Grill",
    "industry": "Outdoor & Sporting",
    "industrySlug": "outdoor-sporting",
    "vocal": "male",
    "mood": "bold",
    "genre": "pop-country",
    "genreLabel": "Pop Country",
    "audioSlug": "",
    "description": "Big pop-country anthem for a propane grill brand. Radio-polished production with a chorus hook built to play over tailgates, backyard gatherings, and outdoor-retail TV spots."
  },
  {
    "brand": "LUMENFIELD",
    "product": "Candles",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "female",
    "mood": "dreamy",
    "genre": "indie-pop",
    "genreLabel": "Indie Pop",
    "audioSlug": "",
    "description": "Moody indie-pop for a premium candle brand. Reverby female vocal, analog synths, and a mellow tempo that pairs with home, dinner, and decor lifestyle creative."
  },
  {
    "brand": "OAKMERE",
    "product": "Furniture",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "female",
    "mood": "luxury",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "",
    "description": "Sophisticated smooth-pop for a furniture brand. Soft pad stack, brushed drums, and a warm female lead. A sound that positions the product as quietly premium."
  },
  {
    "brand": "PAWSLY",
    "product": "Dog Food",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "playful",
    "genre": "feel-good-pop",
    "genreLabel": "Feel-Good Pop",
    "audioSlug": "",
    "description": "Playful feel-good pop for a dog food brand. Kids, dogs, and backyard energy in musical form. A hook engineered to make owners smile within the first four seconds."
  },
  {
    "brand": "PILLOWPEAK",
    "product": "Mattress Topper",
    "industry": "Home & Lifestyle",
    "industrySlug": "home-lifestyle",
    "vocal": "male",
    "mood": "dreamy",
    "genre": "smooth-pop",
    "genreLabel": "Smooth Pop",
    "audioSlug": "",
    "description": "Soft, dreamy smooth pop for a memory-foam mattress topper brand. Lush pad stack and a soothing male vocal that signals rest and comfort before a single word of copy is read."
  },
  {
    "brand": "PINECREST",
    "product": "Trail Mix",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "warm",
    "genre": "acoustic-pop",
    "genreLabel": "Acoustic Pop",
    "audioSlug": "",
    "description": "Mellow acoustic-pop for a trail mix brand. Finger-picked guitar, warm male vocal, and a steady tempo that pairs with outdoor, hiking, and wellness creative."
  },
  {
    "brand": "RESTRISE",
    "product": "Sleep Gummies",
    "industry": "Health & Supplements",
    "industrySlug": "health-supplements",
    "vocal": "female",
    "mood": "dreamy",
    "genre": "indie-pop",
    "genreLabel": "Indie Pop",
    "audioSlug": "",
    "description": "Hushed indie-pop for a sleep gummies brand. Atmospheric production, dreamy female vocal, and a melodic hook that signals rest and recovery from the first bar."
  },
  {
    "brand": "VOLTRIX",
    "product": "Energy Drink",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "male",
    "mood": "energetic",
    "genre": "edm",
    "genreLabel": "EDM",
    "audioSlug": "",
    "description": "High-voltage EDM-pop for an energy drink brand. Festival-scale build, 808 sub, and a shouted male hook engineered to live on gaming and esports placements."
  },
  {
    "brand": "ZESTRA",
    "product": "Cola",
    "industry": "Food & Bev",
    "industrySlug": "food-bev",
    "vocal": "female",
    "mood": "playful",
    "genre": "upbeat-pop",
    "genreLabel": "Upbeat Pop",
    "audioSlug": "",
    "description": "Bubbly upbeat pop for a craft soda brand. Retro synths, hand-claps, and a confident female lead that captures the fizz and pop of the product category."
  }
];

export const VOCAL_OPTIONS = ['all', 'duet', 'female', 'male'] as const;
export const MOOD_OPTIONS = ['all', 'bold', 'chill', 'dreamy', 'energetic', 'luxury', 'playful', 'warm'] as const;
export const INDUSTRY_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'apparel-accessories', label: 'Apparel & Accessories' },
  { value: 'beauty-personal-care', label: 'Beauty & Personal Care' },
  { value: 'cleaning-household', label: 'Cleaning & Household' },
  { value: 'food-bev', label: 'Food & Bev' },
  { value: 'health-supplements', label: 'Health & Supplements' },
  { value: 'home-lifestyle', label: 'Home & Lifestyle' },
  { value: 'kitchen-cookware', label: 'Kitchen & Cookware' },
  { value: 'outdoor-sporting', label: 'Outdoor & Sporting' },
];
export const GENRE_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'acoustic-pop', label: 'Acoustic Pop' },
  { value: 'country', label: 'Country' },
  { value: 'edm', label: 'EDM' },
  { value: 'feel-good-pop', label: 'Feel-Good Pop' },
  { value: 'indie-pop', label: 'Indie Pop' },
  { value: 'pop-country', label: 'Pop Country' },
  { value: 'smooth-pop', label: 'Smooth Pop' },
  { value: 'soul-r-b', label: 'Soul/R&B' },
  { value: 'tropical', label: 'Tropical' },
  { value: 'upbeat-pop', label: 'Upbeat Pop' },
];
